<button
  class="btn btn-light selected-scale"
  atxDropdown
  [atxDropdownMenu]="menu"
  [disabled]="disabled"
>
  {{
    scaleDisplayObject && scaleDisplayObject[selected]
      ? scaleDisplayObject[selected]
      : selected
  }}
  <fa-icon [icon]="['fas', 'chevron-down']" size="xs"></fa-icon>
</button>
<atx-dropdown-menu #menu="atxDropdownMenu">
  @for (scale of scales; track trackByScale($index, scale)) {
  <atx-dropdown-item
    [active]="selected === scale"
    (click)="handleSelect(scale)"
  >
    {{
      scaleDisplayObject && scaleDisplayObject[selected]
        ? scaleDisplayObject[scale]
        : scale
    }}
  </atx-dropdown-item>
  }
</atx-dropdown-menu>
